import React from "react";
import Container from "@/components/marketing/Container";
import { User, Building2, Search, Bot } from "lucide-react";

const SCOPES = [
  {
    icon: User,
    title: "Personal keywords",
    desc: "Your name, executive bylines, and founder profile — so the first page of results tells the story you want told.",
  },
  {
    icon: Building2,
    title: "Brand keywords",
    desc: "Your company and product names — so owned and earned coverage outranks reviews, forums, and unrelated mentions.",
  },
  {
    icon: Search,
    title: "Search results",
    desc: "The full first page of Google for your name and brand, shaped with placements, press, and structured data.",
  },
  {
    icon: Bot,
    title: "AI search visibility",
    desc: "How ChatGPT, Gemini, and Perplexity describe you — driven by the authoritative coverage we place.",
  },
];

export default function KeywordScope() {
  return (
    <section className="py-7 sm:py-9 lg:py-12 bg-slate/30">
      <Container>
        <div className="text-center mb-12 lg:mb-16">
          <span className="meta-tag inline-block mb-4">WHAT WE MANAGE</span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-bone leading-tight mb-4">
            Personal and brand keywords, fully managed.
          </h2>
          <p className="text-steel text-base lg:text-lg max-w-2xl mx-auto leading-relaxed">
            We tailor every Digital24 service around the keywords that matter most — the ones people type when they look you up.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {SCOPES.map((s) => (
            <div key={s.title} className="bg-white border border-[#e8e6ef] rounded-xl p-6">
              <div className="w-11 h-11 rounded-lg bg-cobalt/10 flex items-center justify-center mb-4">
                <s.icon className="w-5 h-5 text-cobalt" />
              </div>
              <h3 className="font-heading text-base font-semibold text-bone mb-2">{s.title}</h3>
              <p className="text-sm text-steel leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}